import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  LinearProgress,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import Page from "src/components/Page";
import PurchaseRequisitionReport from "src/components/reports/PurchaseRequisitionReport";
import ReactToPrint from "react-to-print";
import {
  getPurchaseDetails,
  getPurchaseExpense,
  getPurchaseRequestPrintById,
} from "src/redux/actions/purchaseRequest.action";
import { getBrands } from "src/redux/actions/brand.action";
import {
  fetchCurrencies,
  findAllBrand,
  findAllDepartment,
} from "src/redux/actions/reference.action";
import Moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

export default function PrintPurchaseRequistionPage() {
  const classes = useStyles();

  const refPrint = useRef(null);

  const dispatch = useDispatch();
  const params = useParams();

  const {
    result: {
      countryid,
      currencyid,
      companyid,
      secureid,
      currency_code,
      country,
    },
  } = useSelector((state) => state.loginReducer);

  const brandReducer = useSelector((state) => state.brandReducer);
  const { allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );
  const { currencies } = useSelector((state) => state.referenceReducer);

  const { purchaseRequest, purchaseRequestDetails, purchaseRequesteExpense } =
    useSelector((state) => state.purchaseRequestReducer);

  useEffect(() => {
    dispatch(getPurchaseRequestPrintById(params.id));
    dispatch(getPurchaseDetails(params.id));
    dispatch(getPurchaseExpense(params.id));
    dispatch(getBrands(countryid, companyid, secureid));
    dispatch(fetchCurrencies(currencyid));
    dispatch(findAllDepartment());
    dispatch(findAllBrand());
    return () => {};
  }, [params]);

  if (
    allDepartments.isLoading ||
    allBrands.isLoading ||
    currencies.isLoading ||
    purchaseRequest.isLoading ||
    purchaseRequestDetails.isLoading ||
    purchaseRequesteExpense.isLoading
  ) {
    return (
      <Page className={classes.root} title={``}>
        <Container maxWidth="md">
          <Card>
            <CardHeader
              subheader="For the purchase requisition on the system."
              title="Purchase Requesition Print"
              action={
                <ReactToPrint
                  trigger={() => <Button variant="contained">Print</Button>}
                  content={() => refPrint.current}
                />
              }
            />
            <Divider />
            <CardContent>
              <LinearProgress />
            </CardContent>
          </Card>
        </Container>
      </Page>
    );
  }

  return (
    <Page className={classes.root} title={``}>
      <Container maxWidth="md">
        <Card>
          <CardHeader
            subheader="For the purchase requisition on the system."
            title="Purchase Requesition Print"
            action={
              <ReactToPrint
                trigger={() => <Button variant="contained">Print</Button>}
                content={() => refPrint.current}
              />
            }
          />
          <Divider />
          <CardContent>
            <PurchaseRequisitionReport
              headers={{
                REQUESTER: purchaseRequest.data.POSTED_NAME,
                REQUESTED_DATE:
                  purchaseRequest.data.PR_STATUS === 10
                    ? Moment().format("DD-MM-YYYY HH:mm:ss")
                    : Moment.utc(purchaseRequest.data.POSTED_DATE)
                        .local("Asia/Bangkok")
                        .format("DD-MM-YYYY HH:mm:ss"),
                ASSIGN_APPROVE_NAME: purchaseRequest.data.ASSIGN_APPROVE_NAME
                  ? purchaseRequest.data.ASSIGN_APPROVE_NAME
                  : "",
                APPROVED_DATE:
                  purchaseRequest.data.PR_STATUS === 30
                    ? Moment.utc(purchaseRequest.data.APPROVED_DATE)
                        .local("Asia/Bangkok")
                        .format("DD-MM-YYYY HH:mm:ss")
                    : "",
                EMAIL: purchaseRequest.data.POSTED_EMAIL,
                COMPANY: country,
                PR_NO: purchaseRequest.data.PR_NO,
                REF_PR_NO: purchaseRequest.data.REF_PR_NO,
                CREATED_DATE: purchaseRequest.data.CREATED_DATE,
                UPDATED_AT: purchaseRequest.data.UPDATED_AT,
                PR_STATUS: purchaseRequest.data.PR_STATUS,
                POST_DATE: purchaseRequest.data.POST_DATE,
                BUDGET_AMOUNT_CURRENCY: currency_code,
                BRAND_NAME: purchaseRequest.data.PR_BRANDID_NAME,
                DEPARTMENT: purchaseRequest.data.PR_DEPARTID_NAME,
                REQUESTOR_TITLE: purchaseRequest.data.REQUESTOR_TITLE,
                REQUESTOR_DOA_LEVEL: purchaseRequest.data.REQUESTOR_DOA_LEVEL,
                REVIEWER_TITLE: purchaseRequest.data.REVIEWER_TITLE,
                REVIEWER_DOA_LEVEL: purchaseRequest.data.REVIEWER_DOA_LEVEL,
                APPROVER_TITLE: purchaseRequest.data.APPROVER_TITLE,
                APPROVER_DOA_LEVEL: purchaseRequest.data.APPROVER_DOA_LEVEL,
                REVIEWER_NAME: purchaseRequest.data.REVIEWER_NAME,
                REVIEWER_REVIEWED_DATE: purchaseRequest.data
                  .REVIEWER_REVIEWED_DATE
                  ? Moment.utc(purchaseRequest.data.REVIEWER_REVIEWED_DATE)
                      .local("Asia/Bangkok")
                      .format("DD-MM-YYYY HH:mm:ss")
                  : "",
                WATERMARK: [10, 20, 6].includes(purchaseRequest.data.PR_STATUS)
                  ? "DRAFT"
                  : "",
                PRINT_TYPE:
                  purchaseRequest.data.PRINT_TIME === 1
                    ? "(Original)"
                    : `(Re-Print)`,
              }}
              ref={(el) => (refPrint.current = el)}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
